import Annotation from '../Annotation';

/** Text Annotation */
export default class TextAnnotation extends Annotation {
	_getDefaultParams() {
		return {
			date: null,
			value: null,
			text: 'Text',
			x: null,
			y: null,
			style: this.core.getStyle('annotation.text')
		};
	}

	render() {
		const { panel, params } = this;
		const ctx = panel.rootContext;
		const xScale = panel.xAxis.primaryScale;
		const yScale = panel.yAxis.primaryScale;
		let x0 = typeof params.x === 'number' ? params.x : xScale(this.core.closestExchangeIndex(new Date(params.date)));
		let y0 = typeof params.y === 'number' ? params.y : yScale(params.value);
		x0 += params.style.padding.left;
		x0 -= params.style.padding.right;
		y0 += params.style.padding.top;
		y0 -= params.style.padding.bottom;
		ctx.textAlign = params.style.textAlign;
		ctx.textBaseline = params.style.textBaseline;
		ctx.fillStyle = params.style.color;
		ctx.font = panel.getFontStyle(params.style.font.weight, params.style.font.size, params.style.font.family);
		panel.glowText(
			ctx,
			params.text,
			x0,
			y0,
			params.style.color,
			params.style.glow.color,
			params.style.glow.width
		);
	}
}
